import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

export function NavTabItem({ to, label, count, ...props }) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        /*
         * Tabs are the only place brand marks navigation — a 2px brand-600
         * underline. No pill, no fill: enough to find, not enough to compete
         * with status colour in the table below.
         */
        `inline-flex items-center gap-2 h-10 px-3 text-sm transition-colors rounded-t focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand-600${
          isActive
            ? ' font-semibold text-brand-700 shadow-[inset_0_-2px_0_rgb(var(--brand-600))]'
            : ' font-medium text-neutral-600 hover:bg-neutral-100 hover:text-neutral-900'
        }`
      }
      {...props}
    >
      <span>{label}</span>
      {count ? <span className="badge-count">{count}</span> : null}
    </NavLink>
  );
}

NavTabItem.defaultProps = {
  count: '',
};

NavTabItem.propTypes = {
  to: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  count: PropTypes.string,
};

function NavTab({ children }) {
  return (
    <div className="bg-white border-b border-neutral-200">
      <div className="w-full px-2 flex items-center gap-1 overflow-x-auto whitespace-nowrap">
        {children}
      </div>
    </div>
  );
}

NavTab.propTypes = {
  children: PropTypes.instanceOf(Object).isRequired,
};

export default NavTab;
